"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _amb = _interopRequireDefault(require("./amb.Logger"));

var _amb2 = require("./amb.Helper");

var _amb3 = _interopRequireDefault(require("./amb.MessageClientBuilder"));

var _amb4 = _interopRequireDefault(require("./amb.MessagesRedeliveryManager"));

var _amb5 = _interopRequireDefault(require("./amb.Properties"));

var _amb6 = require("./amb.Constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Channel = function Channel(cometd, channelName, initialized) {
  var subscribeOptionsCallback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {
    return {};
  };
  var subscription = null;
  var subscriptionCallbackResponse = null;
  var listeners = [];
  var listenerCallbackQueue = [];
  var LOGGER = new _amb.default('amb.Channel');
  var idCounter = 0;
  var _initialized = initialized;
  var lastMessageNumber = -1;
  var lastMessageShard = null;
  var OUTGOING_EXT_MSG_NUM = 'last_msg_num';
  var OUTGOING_EXT_MSG_SHARD = 'last_msg_shard';
  var OUTGOING_EXT_REQUEST_DURATION = 'request_duration';
  var readyToDeliver = true;
  var redeliveryManager = new _amb4.default();

  function _disconnected() {
    var status = cometd.getStatus();
    return status === 'disconnecting' || status === 'disconnected';
  }

  function getSubscriptionCommandSender() {
    return (0, _amb3.default)().getServerConnection().getSubscriptionCommandSender();
  }

  return {
    /**
     * Subscribe to have this channel's messages be published to the specified
     * callback.
     *
     * @return Integer id for the newly registered listener
     */
    subscribe:
    /*Integer*/
    function subscribe(listener) {
      if (!listener.getCallback()) {
        LOGGER.addErrorMessage('Cannot subscribe to channel: ' + channelName + ', callback not provided');
        return;
      }

      for (var i = 0; i < listeners.length; i++) {
        if (listeners[i] === listener) {
          LOGGER.debug('Channel listener already in the list');
          return listener.getID();
        }
      }

      listeners.push(listener);
      var listenerSubCallback = listener.getSubscriptionCallback();

      if (listenerSubCallback) {
        if (subscriptionCallbackResponse) {
          listenerSubCallback(subscriptionCallbackResponse);
        } else {
          listenerCallbackQueue.push(listenerSubCallback);
        }
      }

      if (!subscription && _initialized) {
        try {
          this.subscribeToCometD();
        } catch (e) {
          LOGGER.addErrorMessage(e);
          return;
        }
      }

      return ++idCounter;
    },
    resubscribe:
    /*void*/
    function resubscribe() {
      subscription = null;

      for (var i = 0; i < listeners.length; i++) {
        listeners[i].resubscribe();
      }
    },
    _handleResponse:
    /*void*/
    function _handleResponse(
    /*Hash*/
    message) {
      if (readyToDeliver) this.processMessageCallback(message);else this.processReSubscriptionMessages(message);
    },
    processReSubscriptionMessages: function processReSubscriptionMessages(message) {
      var _this = this;

      var deliver = redeliveryManager.shouldDeliver(message);

      if (deliver) {
        LOGGER.debug(_amb6.CHANNEL_READY_TO_DELIVER + channelName);
        readyToDeliver = true;
        this.processMessageCallback(message);
      } else if (redeliveryManager.shouldDeliverPendingMessages()) redeliveryManager.getAllPendingMessages().forEach(function (item) {
        return _this.processMessageCallback(item);
      });
    },
    processMessageCallback: function processMessageCallback(message) {
      for (var i = 0; i < listeners.length; i++) {
        listeners[i].getCallback()(message);
      }

      if (redeliveryManager.containsMetaInfo(message)) {
        lastMessageNumber = message.ext[_amb6.MSG_NUM];
        lastMessageShard = message.ext[_amb6.MSG_SHARD];
      }
    },

    /**
     * Remove listener from channel, so callback pertaining to listener
     * no longer receives messages published to channel. When the last
     * listener is removed, the subscription is destroyed.
     */
    unsubscribe:
    /*void*/
    function unsubscribe(
    /*amb.ChannelListener*/
    listener) {
      if (!listener) {
        LOGGER.addErrorMessage('Cannot unsubscribe from channel: ' + channelName + ', listener argument does not exist');
        return;
      } // Remove listener


      for (var i = 0; i < listeners.length; i++) {
        if (listeners[i].getID() === listener.getID()) {
          listeners.splice(i, 1);
          break;
        }
      } // Unsubscribe if we've removed the last listener


      if (listeners.length < 1 && subscription && !_disconnected()) this.unsubscribeFromCometD();
    },
    publish:
    /*void*/
    function publish(
    /*Hash*/
    message,
    /*Function*/
    callback) {
      cometd.publish(channelName, message, callback);
    },
    subscribeToCometD:
    /*void*/
    function subscribeToCometD() {
      LOGGER.debug("subscribeToCometD channelName : " + channelName + ", subscription : " + subscription);
      if (getSubscriptionCommandSender()) getSubscriptionCommandSender().subscribeToChannel(this);else this._subscribeToCometD(this.subscriptionCallback);
    },
    _subscribeToCometD: function _subscribeToCometD(overLoadedSubscriptionCallBack) {
      LOGGER.debug("_subscribeToCometD channelName : " + channelName);

      var subscribeOptions = this._populateSubscriptionOptions();

      if ((0, _amb2.isNil)(subscribeOptions) || (0, _amb2.isEmptyObject)(subscribeOptions)) subscription = cometd.subscribe(channelName, this._handleResponse.bind(this), overLoadedSubscriptionCallBack);else {
        var subscribeOptionsWrapper = {
          "subscribeOptions": subscribeOptions
        };
        subscription = cometd.subscribe(channelName, this._handleResponse.bind(this), subscribeOptionsWrapper, overLoadedSubscriptionCallBack);
      }
      LOGGER.debug('Successfully subscribed to channel: ' + channelName + ', subscribeOptions: ' + JSON.stringify(subscribeOptions));
    },
    _populateSubscriptionOptions: function _populateSubscriptionOptions() {
      var subscribeOptions = subscribeOptionsCallback();
      var durationSinceLastMessageReceived = Date.now() - this.fetchDisconnectionTS();

      if (this._shouldRedeliveryBeRequested(durationSinceLastMessageReceived)) {
        if ((0, _amb2.isNil)(subscribeOptions)) subscribeOptions = {};
        subscribeOptions[_amb6.MESSAGE_REDELIVERY_OPTIONS] = {};
        subscribeOptions[_amb6.MESSAGE_REDELIVERY_OPTIONS][OUTGOING_EXT_MSG_NUM] = lastMessageNumber;
        subscribeOptions[_amb6.MESSAGE_REDELIVERY_OPTIONS][OUTGOING_EXT_MSG_SHARD] = lastMessageShard;
        subscribeOptions[_amb6.MESSAGE_REDELIVERY_OPTIONS][OUTGOING_EXT_REQUEST_DURATION] = durationSinceLastMessageReceived;
        LOGGER.debug(_amb6.CHANNEL_NOT_READY_TO_DELIVER + channelName);
        readyToDeliver = false;
        redeliveryManager.resetState();
      }

      return subscribeOptions;
    },
    _shouldRedeliveryBeRequested: function _shouldRedeliveryBeRequested(durationSinceLastMessageReceived) {
      return durationSinceLastMessageReceived <= _amb5.default.redeliveryDisconnectTimeoutInMins * 60000 && lastMessageNumber != -1 && !(0, _amb2.isNil)(lastMessageShard);
    },

    /**
     * Callback that gets fired when a cometd channel subscription is completed.
     * Triggers channel listener callbacks.
     * @param response
     */
    subscriptionCallback: function subscriptionCallback(response) {
      LOGGER.debug("Cometd subscription callback completed for channel: " + channelName);
      LOGGER.debug("Listener callback queue size: " + listenerCallbackQueue.length);
      subscriptionCallbackResponse = response;
      listenerCallbackQueue.map(function (listenerSubCallback) {
        listenerSubCallback(subscriptionCallbackResponse);
      });
      listenerCallbackQueue = [];
    },
    unsubscribeFromCometD:
    /*void*/
    function unsubscribeFromCometD() {
      LOGGER.debug("unsubscribeFromCometD  from : " + channelName + ', subscription : ' + subscription);

      if (subscription !== null) {
        if (getSubscriptionCommandSender()) getSubscriptionCommandSender().unsubscribeToChannel(this);else this._unsubscribeFromCometD();
      }
    },
    _unsubscribeFromCometD:
    /*void*/
    function _unsubscribeFromCometD() {
      LOGGER.debug("_unsubscribeFromCometD  from : " + channelName + ', subscription : ' + subscription);

      if (subscription !== null) {
        cometd.unsubscribe(subscription);
        subscription = null;
        subscriptionCallbackResponse = null;
        LOGGER.debug('Successfully unsubscribed from channel: ' + channelName);
      }
    },
    resubscribeToCometD:
    /*void*/
    function resubscribeToCometD() {
      LOGGER.debug("Resubscribe to " + channelName);
      if (getSubscriptionCommandSender()) getSubscriptionCommandSender().subscribeToChannel(this);else this._subscribeToCometD(this.subscriptionCallback);
    },
    getSubscribeOptionsCallback: function getSubscribeOptionsCallback() {
      return subscribeOptionsCallback;
    },
    getName: function getName() {
      return channelName;
    },

    /**
     * Returns the array of amb.ChannelListeners.
     * @returns {Array}
     */
    getChannelListeners: function getChannelListeners() {
      return listeners;
    },
    getLastMessageShard: function getLastMessageShard() {
      return lastMessageShard;
    },
    getLastMessageNumber: function getLastMessageNumber() {
      return lastMessageNumber;
    },
    fetchDisconnectionTS: function fetchDisconnectionTS() {
      var clientDisconnectTime = (0, _amb3.default)().getServerConnection().getConnectionBrokenTS();
      LOGGER.debug("Client Disconnect Time in ms:" + clientDisconnectTime);
      return clientDisconnectTime ? clientDisconnectTime : 0;
    },
    getRedeliveryManager: function getRedeliveryManager() {
      return redeliveryManager;
    },
    isReadyToDeliver: function isReadyToDeliver() {
      return readyToDeliver;
    },

    /**
     * Returns the array of channel listener subscription callbacks
     * For unit testing.
     * @returns {Array}
     */
    getListenerCallbackQueue: function getListenerCallbackQueue() {
      return listenerCallbackQueue;
    },

    /**
     * Don't use this, for unit testing.
     * Need the ability to set the subscription callback response from cometd subscribe callback
     *
     * @param response
     */
    setSubscriptionCallbackResponse: function setSubscriptionCallbackResponse(response) {
      subscriptionCallbackResponse = response;
    }
  };
};

var _default = Channel;
exports.default = _default;